import moment from 'moment';
import 'moment/dist/locale/fr';

moment.updateLocale('en', {
  week: {
    dow: 1,
    doy: 4,
  },
  longDateFormat: {
    LT: 'h:mm a',
    LL: 'dddd, MMMM D, YYYY',
  },
  invalidDate: '',
});

moment.updateLocale('fr', {
  week: {
    dow: 1,
    doy: 4,
  },
  longDateFormat: {
    LT: 'HH [h] mm',
    LL: 'dddd DD MMMM YYYY',
  },
  invalidDate: '',
});
